const returnParamAlternativelyReturnFunctionCall = func => param =>  param ? param : func()
export default returnParamAlternativelyReturnFunctionCall